import { PropertySearchListModel } from "app/modules/main/api/main-clients.api";
import { Box, Card, Grid, Typography } from "@mui/material";
import { NumberHelper } from "app/modules/common/helpers/NumberHelper";
import React from "react";
import { useInstance } from "react-ioc";
import { SearchStore } from "app/modules/main/components/main/search/SearchStore";
import { imageBaseUrl } from "app/modules/main/services/AxiosBaseClient";

export const ResultItem = (props: { item: PropertySearchListModel }) => {
    return <Grid item xs={12} sm={6} md={4} lg={3} xl={3} sx={{ p: 1.5 }}>
        <ResultItemCard item={props.item} />
    </Grid>;
}

export const ResultItemCard = (props: { item: PropertySearchListModel }) => {
    const searchStore = useInstance(SearchStore);

    const handleCardClick = () => {
        const url = "/search/" + props.item.id + searchStore.getBookParams();
        window.open(url, '_blank');
    };

    return <Card sx={{
        cursor: "pointer",
        borderRadius: 3,
        overflow: "hidden",
        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": { transform: "translateY(-4px)", boxShadow: "0 8px 24px rgba(0,0,0,0.15)" }
    }} onClick={handleCardClick}>
        <Box sx={{ position: "relative", overflow: "hidden" }}>
            <img
                src={imageBaseUrl + `/mainController/Search/GetFile?path=${encodeURI(props.item.thumbnailUrl)}`}
                style={{ width: "100%", height: 220, objectFit: "cover", display: "block" }}
            />
        </Box>
        <Box sx={{ p: 2 }}>
            <Typography
                sx={{
                    fontSize: "15px",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    color: "text.primary",
                    mb: 0.5
                }}
            >
                {props.item.name}
            </Typography>
            <Typography sx={{ fontSize: "13px", color: "text.secondary", mb: 1.5 }}>
                {props.item.city}, {props.item.state}
            </Typography>
            <Typography sx={{ fontSize: "13px", color: "text.secondary", mb: 1 }}>
                {props.item.bedrooms} Bedrooms &middot; {props.item.bathroom} Bath &middot; Sleeps {props.item.sleeps}
            </Typography>
            <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "text.primary" }}>
                {NumberHelper.formatUSDollar(props.item.rate)} <Typography component="span" sx={{ fontSize: "13px", fontWeight: 400, color: "text.secondary" }}>avg / night</Typography>
            </Typography>
        </Box>
    </Card>;
}
